export const AccountPaymentTypes = {
    SHOW_PAYMENT: "SHOW_PAYMENT",
    ADD_PAYMENT: "ADD_PAYMENT",
    UPDATE_PAYMENT: "UPDATE_PAYMENT",
    DELETE_PAYMENT: "DELETE_PAYMENT",
};
  